import Vue from 'vue'
/**
 * 模板串转换成vuecomponent的render方法
 * @param vm vue对象
 * @param template 模板串,如果为空则使用options中的template
 * @param components 模板中使用的自定义组件
 */
export const toRender = (vm, template, components) => {
  let options = vm.$options
  let tmpl = template || options.template
  if (!tmpl) {
    return
  }
  let ref = Vue.compile(tmpl, {
    shouldDecodeNewlines: false,
    delimiters: options.delimiters
  }, vm)
  if (components) {
    if (!options.hasOwnProperty('components')) {
      options.components = Object.create(options.components)
    }
    Object.assign(options.components, components)
  }
  options.render = ref.render
  options.staticRenderFns = ref.staticRenderFns
}



// WEBPACK FOOTER //
// ./src/utils/render.js